import { render, staticRenderFns } from "./ZahnwerkstattImpressumPage.vue?vue&type=template&id=096a18f0&scoped=true"
import script from "./ZahnwerkstattImpressumPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattImpressumPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a18f0",
  null
  
)

export default component.exports